import axios from "axios";
import { logout } from "../../redux/auth";
import store from "../../redux/store";
import { TokenService } from "./tokenService";
import { ApiService, sessionExpiredLogout } from "./apiService";

const api = axios.create({
  // baseURL: "http://43.200.72.23",
  withCredentials: true,
});

let _runRefreshToken = 0;
let _clientLogoutTimer = 0;
let _clientMoveTimer = 0;

const refresh = async () => {
  _runRefreshToken = 1;
  const refreshToken = TokenService.getLocalRefreshToken();
  const accessToken = TokenService.getLocalAccessToken();

  let result = false;
  try {
    const response = await ApiService.refreshToken(accessToken, refreshToken)
    sessionStorage.setItem("accessToken", JSON.stringify(response.data.token));
    sessionStorage.setItem("refreshToken", JSON.stringify(response.data.refreshToken));

    result = true;
  }
  catch (error) {
    console.log('refreshTokenError', error)
  }
  _runRefreshToken = 0;
  return result;
}

const parseJwt = (token) => {
  try {
    return JSON.parse(window.atob(token.split(".")[1]));
    // return JSON.parse(atob(token.split(".")[1]));
  }
  catch (e) {
    console.log('parseJwt Error ::', e)
    return null;
  }
};

api.interceptors.request.use(
  (config) => {
    if (!_runRefreshToken) {
      const accessToken = TokenService.getLocalAccessToken();
      if (accessToken) {
        config.headers = {
          'Authorization': `Bearer ${accessToken}`,
        }
      }

      // 사용자의 조작으로 인해 api 호출하는 경우는 해당 내용을 타야함 
      clearTimeout(_clientLogoutTimer); 
      _clientLogoutTimer = setTimeout(sessionExpiredLogout, 60 * 60000); // 60분 후 Logout

    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
)

setInterval(() => {
  // const accessToken = TokenService.getLocalAccessToken();
  const accessToken = sessionStorage.getItem("accessToken");
  const events = ["mousemove", "keydown", "click"];
  // const user = JSON.parse(sessionStorage.getItem("user"));
  if (accessToken) {
    _clientMoveTimer++;
    const decodedJwt = parseJwt(accessToken);
    const now = new Date().getTime();
    const exp = (decodedJwt.exp) * 1000;

    const removeTimer = () => {
      return (_clientMoveTimer = 0);
    };

    events.forEach((event) => {
      window.removeEventListener(event, removeTimer); // 중복 방지
      window.addEventListener(event, removeTimer);
    });

    if ((exp <= now) || (_clientMoveTimer > 600)) {
      // 토큰 리프레시를 하고 새로운 토큰으로 보내도 세션이 끊기면서 오류가있어서
      // 일단 토큰시간 만료(60분)되면 무조건 로그아웃되는걸로 처리함
      // console.log("JWT expired. Logging out...");
      sessionExpiredLogout();
    }
    // if ((exp - 60000) < now) { // 1분 미만이면 갱신
    //   try {
    //     await refresh();
    //     const expireTime = parseJwt(accessToken).exp;
    //     user.expires = new Date(expireTime * 1000).toISOString();
    //     sessionStorage.setItem("user", JSON.stringify(user));
    //   }
    //   catch (e) {
    //     return false;
    //   }
    // }
  }
}, 1000);

const { dispatch } = store;
api.interceptors.response.use(
  (config) => {
    return config;
  },
  (error) => {
    // console.log('error', error.response)
    console.log("error", error.response);
    if (error.response.status === 401) {
      //토큰이 모두 만료됐다는 응답 값을 받으면 세션스토리지를 비워줍니다.
      // alert('권한이 없습니다. 다시 로그인 해주세요')
    	dispatch(logout());
      // window.location.reload();
    }
    return Promise.reject(error);
  },
);

export default api;